import * as types from './actionTypes';
import { apiPost } from '../utils/request';

// --- Live updates pushed from the truck-proxy via the SignalR hub (see utils/truckHub.js) ---

export function truckHubConnection(status) {
    return { type: types.TRUCK_HUB_CONNECTION, status };
}

export function truckHubWeight(weight) {
    return { type: types.TRUCK_HUB_WEIGHT, weight };
}

export function truckHubReceipt(receipt) {
    return { type: types.TRUCK_HUB_RECEIPT, receipt };
}

export function truckHubContext(context) {
    return { type: types.TRUCK_HUB_CONTEXT, context };
}

export function truckHubLocation(location) {
    return { type: types.TRUCK_HUB_LOCATION, location };
}

// --- Pickup context: sent to the cloud API (over the driver's own internet), which relays it to
//     the on-truck device via the hub. Replaces the old direct POST to the truck-proxy over wifi. ---

export function setPickupContext(runId, pickupId, isCollectionRun, tankId = null, run = null, pickup = null) {
    return function (dispatch) {
        const context = {
            truckNumberPlate: run?.truckNumberPlate || null,
            runId,
            pickupId,
            action: 'StartPickup',
            isCollectionRun,
            tankId,
            truckCertNo: run?.truckCertNo || null,
            locationName: pickup?.clientCompanyName || null,
            locationAddress: pickup?.locationFullAddress || null,
            locationLatitude: pickup?.locationLatitude || null,
            locationLongitude: pickup?.locationLongitude || null,
        };

        // Optimistically reflect the context locally so the status view updates immediately.
        // setAt records when the driver set this context (shown in the scales status view).
        dispatch(truckHubContext({ runId, pickupId, tankId, isCollectionRun, setAt: new Date().toISOString() }));

        return apiPost('/api/truckproxy/context', context)
            .then(() => {
                console.log('Set pickup context for pickup', pickupId);
            })
            .catch(err => {
                console.log('Failed to set pickup context', err);
            });
    };
}

export function clearPickupContext() {
    return function (dispatch, getState) {
        const { truckData } = getState();

        const context = {
            truckNumberPlate: truckData?.truckNumberPlate || null,
            runId: 0,
            pickupId: null,
            action: 'EndPickup',
            isCollectionRun: false,
        };

        dispatch(truckHubContext(null));

        return apiPost('/api/truckproxy/context', context)
            .catch(err => {
                console.log('Failed to clear pickup context', err);
            });
    };
}
